import {Link} from "react-router-dom";

export default function MainBlockPrivacy(props) {
    return (
        <section className="main_block main_block_privacy">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Политика конфиденциальности</div>
                </div>
                <h1>
                    <span className="title main_title">Политика конфиденциальности</span>
                </h1>
            </div>
        </section>
    )
}
